export default __webpack_public_path__ + "static/media/SPPLogo.08484329.png";